import { render, staticRenderFns } from "./DemoRangeSliderVertical.vue?vue&type=template&id=304d0d86&"
import script from "./DemoRangeSliderVertical.vue?vue&type=script&lang=js&"
export * from "./DemoRangeSliderVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
installComponents(component, {VRangeSlider})
